import { createSvgComponent } from "../../icon/createSvgComponent";
import BadgeDiscount from "@core/icon/assets/badge-discount.svg";
export default createSvgComponent(BadgeDiscount);